import React, { useState, useEffect, useLayoutEffect } from "react";
import { useIntl, FormattedMessage } from 'react-intl'
import * as Utils from '../../commons/utils/Utils'
import {
  Modal,
  Backdrop,
  Grow,
} from '@material-ui/core';
import Switch from "react-switch";
import SelectWithIcons from "../selectWithIcons/SelectWithIcons.js";
import DatePicker from "react-datepicker";
import moment from 'moment';
import { Portal } from 'react-overlays';
import $ from 'jquery'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'

const CalendarContainer = ({ children }) => {
  return (
    <Portal >
      {children}
    </Portal>
  )
}

const FormulariosGridExport = (props) => {
  const intl = useIntl();
  const [FechaDesde, setFechaDesde] = useState(moment().startOf('year'))
  const [FechaHasta, setFechaHasta] = useState(moment())
  const [tiposFormulario, setTiposFormulario] = useState([])
  const [tipoFormulario, setTipoFormulario] = useState(null)
  const [dataToExport, setDataToExport] = useState(null)
  const [attrDinamicos, setAttrDinamicos] = useState(null)
  const [loading, setLoading] = useState(false);
  const [conTicket, setConTicket] = useState(false);
  const filterQuery = props.filterQuery;
  const [ticket_atributos_total, setTicketAtributosTotal] = useState([
    'servicio',
    'gerenciador',
    'cebe',
    'division',
    'centro_costos',
    'mano_de_obra',
    'repuestos',
    'factura',
  ]);
  const [switchEnabled, setSwitchEnabled] = useState({
    transportadora: ConfigBusiness.get('moviles.transportadora.grilla') === 'true' ? true : false,
    rentadora: ConfigBusiness.get('frontend.rentadora.grilla') === 'true' ? true : false,
  })

  useEffect(() => {
    Utils.getData('/tipoformulario')
      .then((data) => {
        let options = data.map(tipo => {
          return { label: tipo.nombre, id: tipo.id, icono: tipo.icono }
        })
        setTiposFormulario(options)

      }).catch((err) => {
        console.log(err);
      })

    if (!props.modalExport) {
      setFechaDesde(moment().startOf('year'))
      setFechaHasta(moment())
      setTipoFormulario(null)
      setDataToExport(null)
      setAttrDinamicos(null)
      setLoading(false)
    }
  }, [props.modalExport])

  useEffect(() => {
    setDataToExport(null);
    tipoFormulario && Utils.getData('/tipoformulario/' + tipoFormulario)
      .then(data => {
        let toExport = {}
        let attrDinamicos = data.atributos_dinamicos.map((attr) => {
          while (attr.activo) {
            let attrName = attr.nombre;

            toExport[attrName] = true
            return { id: attr.id, nombre: attr.nombre }
          }
        });
        toExport['region'] = true
        toExport['subRegion'] = true
        toExport['horaInicio'] = true
        toExport['horaFin'] = true
        if(data.con_ticket){
          toExport['ticket'] = true
          toExport['dominio'] = true
          toExport['fechaCompletado'] = true
          toExport['usuarioValido'] = true
          toExport['fechaValidado'] = true
          toExport['usuarioCompletado'] = true
          if (data.ticket_atributos_json) {
            let ticket_atributos_array = JSON.parse(data.ticket_atributos_json);
            ticket_atributos_array.forEach(element => {
              if(element==='division'){
                if(ConfigBusiness.get('moviles.trabajaConDivisiones.habilitado') === 'true'){
                  toExport[element] = true
                }
              }else if(element==='cebe'){
                if(ConfigBusiness.get('moviles.cebe.habilitado') === 'true'){
                  toExport[element] = true
                }
              }else{
                toExport[element] = true
              }
            });
          }
        }
        if(data.con_movil && switchEnabled.transportadora){
          toExport['transportadora'] = true
        }
        if(data.con_movil && switchEnabled.rentadora){
          toExport['rentadora'] = true
        }
        setAttrDinamicos(attrDinamicos);
        setDataToExport(toExport);
        setConTicket(data.con_ticket ? true : false)

      }).catch((err) => {
        console.log(err);
      })

  }, [tipoFormulario])

  const handleDataExportChange = (attr) => {
    let dataToExportUpdate = { ...dataToExport }
    dataToExportUpdate[attr.nombre] = !dataToExportUpdate[attr.nombre];
    setDataToExport(dataToExportUpdate)
  }

  const handleExport = () => {
    setLoading(true)
    let dataToExportCopy = JSON.parse(JSON.stringify(dataToExport));
    ticket_atributos_total.forEach(element => {
      if(!dataToExport.hasOwnProperty(element)){
        dataToExportCopy[element] = false;
      }
    });
    let body = JSON.stringify({
      fechaDesde: FechaDesde.format('YYYY-MM-DD'),
      fechaHasta: FechaHasta.format('YYYY-MM-DD'),
      tipoFormulario: tipoFormulario,
      colsAExportar: dataToExportCopy,
      ...filterQuery
    })

    Utils.sendDataBlob('/formulario/exportar-excel', 'POST', body)
      .then(data => {
        let file = new File([data], 'VecFleet-checklist.xlsx')
        let fileUrl = URL.createObjectURL(file)
        $("<a />", {
          href: fileUrl,
          download: "VecFleet-checklist.xlsx"
        }).appendTo("body").get(0).click();
      }
      ).catch((err) => {
        console.log(err)
      }).finally(() => {
        props.setModalExport(false);
        setLoading(false)
      })

  }

  return (
    <Modal open={props.modalExport}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 1000,
      }}
    >
      <Grow in={props.modalExport}>
        <div className="" tabIndex="-1" id="export_modal" role="dialog" aria-labelledby="myModalLabel3">
          <div className="modal-xl modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header bg-fleet">
                <h4 className="modal-title text-white" id="myModalLabel3">
                  <i className="ft-download align-middle icon-modal-title"></i>
                  <FormattedMessage id="formularioGrid.render.export_modal.header_exportar_checklist" defaultMessage=" Exportar Checklist" />
                </h4>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => props.setModalExport(false)}>
                  <span aria-hidden="true">&times; </span>
                </button>
              </div>
              <div className="modal-body modal-grey modal-mh ovf-x-hidden">
                <div className="row">
                  <div className="col-md-12">
                    <form className="form form-horizontal">
                      <div className="form-body">
                        <div className="card pull-up">
                          <div className="card-content">
                            <div className="card-body">
                              <h4 className="form-section">
                                <i className="la la-filter"></i>
                                <FormattedMessage id="formularioGrid.render.export_modal.filter.header_filtros" defaultMessage=" Filtros" />
                                <div className="float-right" style={{ fontSize: '14px' }}>*
                                  <FormattedMessage id="formularioGrid.render.export_modal.filter.campos_requeridos" defaultMessage="campos requeridos" />
                                </div>
                              </h4>
                              <div className="form-group row col-md-12">
                                <label className="col-md-2 label-control col-form-label" htmlFor="fechaDesde">
                                  <FormattedMessage id="formularioGrid.render.export_modal.filter.label_desde" defaultMessage="Desde " />*:
                                </label>
                                <div className="col-md-2">
                                  <DatePicker
                                    popperContainer={CalendarContainer}
                                    id="FechaDesde"
                                    name="FechaDesde"
                                    className="form-control date-picker-placeholder"
                                    placeholderText={intl.formatMessage({ id: 'formularioGrid.render.export_modal.filter.placeholder_desde', defaultMessage: 'DD/MM/AAAA' })}
                                    maxDate={FechaHasta}
                                    openToDate={FechaDesde}
                                    selected={FechaDesde}
                                    onChange={(event, value) => { setFechaDesde(moment(event)) }}
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selectsStart
                                    startDate={FechaDesde}
                                    endDate={FechaHasta}
                                    disabled={loading}
                                  />
                                </div>
                                <label className="col-md-1 label-control col-form-label" htmlFor="fechaHasta">
                                  <FormattedMessage id="formularioGrid.render.export_modal.filter.hasta" defaultMessage="Hasta " />*:
                                </label>
                                <div className="col-md-2">
                                  <DatePicker
                                    popperContainer={CalendarContainer}
                                    id="FechaHasta"
                                    name="FechaHasta"
                                    className="form-control date-picker-placeholder"
                                    placeholderText={intl.formatMessage({ id: 'formularioGrid.render.export_modal.filter.placeholder_hasta', defaultMessage: 'DD/MM/AAAA' })}
                                    minDate={FechaDesde}
                                    maxDate={moment()}
                                    openToDate={FechaHasta}
                                    selected={FechaHasta}
                                    onChange={(event, value) => { setFechaHasta(moment(event)) }}
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selectsEnd
                                    startDate={FechaDesde}
                                    endDate={FechaHasta}
                                    disabled={loading}
                                  />
                                </div>
                                <label className="col-md-2 label-control col-form-label" htmlFor="tipoFormulario">
                                  <FormattedMessage id="formularioGrid.render.export_modal.filter.tipo_checklist" defaultMessage="Tipo de Checklist " />*:
                                </label>
                                <div className="col-md-3">
                                  <SelectWithIcons
                                    placeholder="Seleccione"
                                    valueKey="id"
                                    labelKey="label"
                                    clearable={false}
                                    disabled={loading}
                                    onChange={(e) => setTipoFormulario(e.id)}
                                    value={tipoFormulario}
                                    options={tiposFormulario}
                                  />

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card pull-up">
                          <div className="card-content">
                            <div className="card-body">
                              <h4 className="form-section">
                                <i className="la la-columns"></i>
                                <FormattedMessage id="formularioGrid.render.export_modal.columns_export.header_columnas_a_exportar" defaultMessage=" Columnas a exportar" />
                              </h4>
                              {dataToExport == null ? (
                                <label>
                                  <FormattedMessage id="formularioGrid.render.export_modal_seleccione_tipo_de_ckecklist" defaultMessage=" Seleccione Tipo de Checklist para continuar" />
                                </label>
                              ) : (
                                <>
                                <div className="row m-1">
                                  {attrDinamicos !== null ?
                                    attrDinamicos.map((attr) => {
                                      return attr && (
                                        <div className="col-md-3" key={attr.id}>
                                          <label className="col-md-6 label-control col-form-label" htmlFor={attr.nombre}>
                                            {attr.nombre}
                                          </label>
                                          <Switch
                                            className="col-md-6 align-middle"
                                            id={attr.nombre}
                                            name={attr.nombre}
                                            value={attr.id}
                                            onChange={(event) => handleDataExportChange(attr)}
                                            checked={dataToExport[attr.nombre]}
                                            offColor="#FF4961"
                                            onColor="#28D094"
                                            disabled={loading}
                                          />
                                        </div>
                                      )
                                    }) : ''}
                                 {/* Region */}
                                 <div className="col-md-3">
                                   <label className="col-md-6 label-control col-form-label" htmlFor="region">
                                     <FormattedMessage id="ticketsGrid.render.export_modal.columns_export.label_region" defaultMessage="Región:"/>
                                   </label>
                                   <Switch
                                     onChange={(event) => handleDataExportChange({nombre: 'region'})}
                                     checked = {dataToExport['region']}
                                     value={dataToExport['region']}
                                     id = "region"
                                     name = "region"
                                     offColor = "#FF4961"
                                     onColor = "#28D094"
                                     disabled = {loading}
                                     className = "col-md-6 align-middle"
                                   />
                                 </div>
                                 {/* SubRegion */}
                                 <div className="col-md-3">
                                   <label className="col-md-6 label-control col-form-label" htmlFor="subRegion">
                                     <FormattedMessage id="ticketsGrid.render.export_modal.columns_export.label_subRegion" defaultMessage="Sub-Región:"/>
                                   </label>
                                   <Switch
                                     onChange={(event) => handleDataExportChange({nombre: 'subRegion'})}
                                     checked = {dataToExport['subRegion']}
                                     value={dataToExport['subRegion']}
                                     id = "subRegion"
                                     name = "subRegion"
                                     offColor = "#FF4961"
                                     onColor = "#28D094"
                                     disabled = {loading}
                                     className =  "col-md-6 align-middle"
                                   />
                                 </div>
                                 {/* Transportadora */}
                                 {switchEnabled.transportadora ?
                                    <div className="col-md-3">
                                      <label className="col-md-6 label-control col-form-label" htmlFor="transportadora">
                                        <FormattedMessage id="ticketsGrid.render.export_modal.columns_export.label_transportadora" defaultMessage="transportadora"/>:
                                      </label>
                                      <Switch
                                        onChange={(event) => handleDataExportChange({nombre: 'transportadora'})}
                                        checked = {dataToExport['transportadora']}
                                        value={dataToExport['transportadora']}
                                        id = "transportadora"
                                        name = "transportadora"
                                        offColor = "#FF4961"
                                        onColor = "#28D094"
                                        disabled = {loading}
                                        className =  "col-md-6 align-middle"
                                      />
                                    </div>
                                  : null
                                  }
                                  {/* Rentadora */}
                                 {switchEnabled.rentadora ?
                                    <div className="col-md-3">
                                      <label className="col-md-6 label-control col-form-label" htmlFor="rentadora">
                                        <FormattedMessage id="ticketsGrid.render.export_modal.columns_export.label_rentadora" defaultMessage="Rentadora"/>:
                                      </label>
                                      <Switch
                                        onChange={(event) => handleDataExportChange({nombre: 'rentadora'})}
                                        checked = {dataToExport['rentadora']}
                                        value={dataToExport['rentadora']}
                                        id = "rentadora"
                                        name = "rentadora"
                                        offColor = "#FF4961"
                                        onColor = "#28D094"
                                        disabled = {loading}
                                        className =  "col-md-6 align-middle"
                                      />
                                    </div>
                                  : null
                                  }
                                 { conTicket ? 
                                  (<>
                                    <div className="col-md-3">
                                      <label className="col-md-6 label-control col-form-label" htmlFor="ticket">
                                        <FormattedMessage id="Nro_de_ticket" defaultMessage="Nro. de ticket"/>:
                                      </label>
                                      <Switch
                                        onChange={(event) => handleDataExportChange({nombre: 'ticket'})}
                                        checked = {dataToExport['ticket']}
                                        value={dataToExport['ticket']}
                                        id = "ticket"
                                        name = "ticket"
                                        offColor = "#FF4961"
                                        onColor = "#28D094"
                                        disabled = {loading}
                                        className =  "col-md-6 align-middle"
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <label className="col-md-6 label-control col-form-label" htmlFor="dominio">
                                        <FormattedMessage id="Dominio_del_vehiculo" defaultMessage="Dominio del vehículo"/>:
                                      </label>
                                      <Switch
                                        onChange={(event) => handleDataExportChange({nombre: 'dominio'})}
                                        checked = {dataToExport['dominio']}
                                        value={dataToExport['dominio']}
                                        id = "dominio"
                                        name = "dominio"
                                        offColor = "#FF4961"
                                        onColor = "#28D094"
                                        disabled = {loading}
                                        className =  "col-md-6 align-middle"
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <label className="col-md-6 label-control col-form-label" htmlFor="usuarioCompletado">
                                        <FormattedMessage id="Usuario_que_completo_el_checklist" defaultMessage="Usuario que completó el checklist"/>:
                                      </label>
                                      <Switch
                                        onChange={(event) => handleDataExportChange({nombre: 'usuarioCompletado'})}
                                        checked = {dataToExport['usuarioCompletado']}
                                        value={dataToExport['usuarioCompletado']}
                                        id = "usuarioCompletado"
                                        name = "usuarioCompletado"
                                        offColor = "#FF4961"
                                        onColor = "#28D094"
                                        disabled = {loading}
                                        className =  "col-md-6 align-middle"
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <label className="col-md-6 label-control col-form-label" htmlFor="fechaCompletado">
                                        <FormattedMessage id="Fecha_que_se_completo_el_checklist" defaultMessage="Fecha que se completó el checklist"/>:
                                      </label>
                                      <Switch
                                        onChange={(event) => handleDataExportChange({nombre: 'fechaCompletado'})}
                                        checked = {dataToExport['fechaCompletado']}
                                        value={dataToExport['fechaCompletado']}
                                        id = "fechaCompletado"
                                        name = "fechaCompletado"
                                        offColor = "#FF4961"
                                        onColor = "#28D094"
                                        disabled = {loading}
                                        className =  "col-md-6 align-middle"
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <label className="col-md-6 label-control col-form-label" htmlFor="usuarioValido">
                                        <FormattedMessage id="Usuario_que_valido_el_checklist" defaultMessage="Usuario que validó el checklist"/>:
                                      </label>
                                      <Switch
                                        onChange={(event) => handleDataExportChange({nombre: 'usuarioValido'})}
                                        checked = {dataToExport['usuarioValido']}
                                        value={dataToExport['usuarioValido']}
                                        id = "usuarioValido"
                                        name = "usuarioValido"
                                        offColor = "#FF4961"
                                        onColor = "#28D094"
                                        disabled = {loading}
                                        className =  "col-md-6 align-middle"
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <label className="col-md-6 label-control col-form-label" htmlFor="fechaValidado">
                                        <FormattedMessage id="Fecha_que_se_valido_el_checklist" defaultMessage="Fecha que se validó el checklist"/>:
                                      </label>
                                      <Switch
                                        onChange={(event) => handleDataExportChange({nombre: 'fechaValidado'})}
                                        checked = {dataToExport['fechaValidado']}
                                        value={dataToExport['fechaValidado']}
                                        id = "fechaValidado"
                                        name = "fechaValidado"
                                        offColor = "#FF4961"
                                        onColor = "#28D094"
                                        disabled = {loading}
                                        className =  "col-md-6 align-middle"
                                      />
                                    </div>
                                    {dataToExport.hasOwnProperty('servicio') ? 
                                      <div className="col-md-3">
                                        <label className="col-md-6 label-control col-form-label" htmlFor="servicio">
                                          <FormattedMessage id="Servicio" defaultMessage="Servicio"/>:
                                        </label>
                                        <Switch
                                          onChange={(event) => handleDataExportChange({nombre: 'servicio'})}
                                          checked = {dataToExport['servicio']}
                                          value={dataToExport['servicio']}
                                          id = "servicio"
                                          name = "servicio"
                                          offColor = "#FF4961"
                                          onColor = "#28D094"
                                          disabled = {loading}
                                          className =  "col-md-6 align-middle"
                                        />
                                      </div>
                                      : null
                                    }
                                    {dataToExport.hasOwnProperty('gerenciador') ? 
                                      <div className="col-md-3">
                                        <label className="col-md-6 label-control col-form-label" htmlFor="gerenciador">
                                          <FormattedMessage id="Gerenciador" defaultMessage="Gerenciador"/>:
                                        </label>
                                        <Switch
                                          onChange={(event) => handleDataExportChange({nombre: 'gerenciador'})}
                                          checked = {dataToExport['gerenciador']}
                                          value={dataToExport['gerenciador']}
                                          id = "gerenciador"
                                          name = "gerenciador"
                                          offColor = "#FF4961"
                                          onColor = "#28D094"
                                          disabled = {loading}
                                          className =  "col-md-6 align-middle"
                                        />
                                      </div>
                                      : null
                                    }
                                    {dataToExport.hasOwnProperty('centro_costos')? 
                                      <div className="col-md-3">
                                        <label className="col-md-6 label-control col-form-label" htmlFor="centro_costos">
                                          <FormattedMessage id="Centro_de_costos" defaultMessage="Centro de costos"/>:
                                        </label>
                                        <Switch
                                          onChange={(event) => handleDataExportChange({nombre: 'centro_costos'})}
                                          checked = {dataToExport['centro_costos']}
                                          value={dataToExport['centro_costos']}
                                          id = "centro_costos"
                                          name = "centro_costos"
                                          offColor = "#FF4961"
                                          onColor = "#28D094"
                                          disabled = {loading}
                                          className =  "col-md-6 align-middle"
                                        />
                                      </div>
                                      : null
                                    }
                                    {dataToExport.hasOwnProperty('cebe')? 
                                      <div className="col-md-3">
                                        <label className="col-md-6 label-control col-form-label" htmlFor="cebe">
                                          <FormattedMessage id="Centro_de_beneficios" defaultMessage="Centro de beneficios"/>:
                                        </label>
                                        <Switch
                                          onChange={(event) => handleDataExportChange({nombre: 'cebe'})}
                                          checked = {dataToExport['cebe']}
                                          value={dataToExport['cebe']}
                                          id = "cebe"
                                          name = "cebe"
                                          offColor = "#FF4961"
                                          onColor = "#28D094"
                                          disabled = {loading}
                                          className =  "col-md-6 align-middle"
                                        />
                                      </div>
                                      : null
                                    }
                                    {dataToExport.hasOwnProperty('division') ? 
                                      <div className="col-md-3">
                                        <label className="col-md-6 label-control col-form-label" htmlFor="division">
                                          <FormattedMessage id="division" defaultMessage="Division"/>:
                                        </label>
                                        <Switch
                                          onChange={(event) => handleDataExportChange({nombre: 'division'})}
                                          checked = {dataToExport['division']}
                                          value={dataToExport['division']}
                                          id = "division"
                                          name = "division"
                                          offColor = "#FF4961"
                                          onColor = "#28D094"
                                          disabled = {loading}
                                          className =  "col-md-6 align-middle"
                                        />
                                      </div>
                                      : null
                                    }
                                    {dataToExport.hasOwnProperty('mano_de_obra') ? 
                                      <div className="col-md-3">
                                        <label className="col-md-6 label-control col-form-label" htmlFor="mano_de_obra">
                                          <FormattedMessage id="Presupuesto_mano_de_obra" defaultMessage="Presupuesto mano de obra"/>:
                                        </label>
                                        <Switch
                                          onChange={(event) => handleDataExportChange({nombre: 'mano_de_obra'})}
                                          checked = {dataToExport['mano_de_obra']}
                                          value={dataToExport['mano_de_obra']}
                                          id = "mano_de_obra"
                                          name = "mano_de_obra"
                                          offColor = "#FF4961"
                                          onColor = "#28D094"
                                          disabled = {loading}
                                          className =  "col-md-6 align-middle"
                                        />
                                      </div>
                                      : null
                                    }
                                    {dataToExport.hasOwnProperty('repuestos') ? 
                                      <div className="col-md-3">
                                        <label className="col-md-6 label-control col-form-label" htmlFor="repuestos">
                                          <FormattedMessage id="presupuesto_de_repuestos" defaultMessage="Presupuesto de repuestos"/>:
                                        </label>
                                        <Switch
                                          onChange={(event) => handleDataExportChange({nombre: 'repuestos'})}
                                          checked = {dataToExport['repuestos']}
                                          value={dataToExport['repuestos']}
                                          id = "repuestos"
                                          name = "repuestos"
                                          offColor = "#FF4961"
                                          onColor = "#28D094"
                                          disabled = {loading}
                                          className =  "col-md-6 align-middle"
                                        />
                                      </div>
                                      : null
                                    }
                                    {dataToExport.hasOwnProperty('factura') ? 
                                      <div className="col-md-3">
                                        <label className="col-md-6 label-control col-form-label" htmlFor="factura">
                                          <FormattedMessage id="Factura" defaultMessage="Factura"/>:
                                        </label>
                                        <Switch
                                          onChange={(event) => handleDataExportChange({nombre: 'factura'})}
                                          checked = {dataToExport['factura']}
                                          value={dataToExport['factura']}
                                          id = "factura"
                                          name = "factura"
                                          offColor = "#FF4961"
                                          onColor = "#28D094"
                                          disabled = {loading}
                                          className =  "col-md-6 align-middle"
                                        />
                                      </div>
                                      : null
                                    }
                                  </>)
                                : ''}
                                <div className="col-md-3">
                                  <label className="col-md-6 label-control col-form-label" htmlFor="horaInicio">
                                    <FormattedMessage id="FormulariosGridExport.Hora_de_inicio" defaultMessage="Hora de inicio"/>:
                                  </label>
                                  <Switch
                                    onChange={(event) => handleDataExportChange({nombre: 'horaInicio'})}
                                    checked = {dataToExport['horaInicio']}
                                    value={dataToExport['horaInicio']}
                                    id = "horaInicio"
                                    name = "horaInicio"
                                    offColor = "#FF4961"
                                    onColor = "#28D094"
                                    disabled = {loading}
                                    className =  "col-md-6 align-middle"
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label className="col-md-6 label-control col-form-label" htmlFor="horaFin">
                                    <FormattedMessage id="FormulariosGridExport.Hora_de_fin" defaultMessage="Hora de finalización"/>:
                                  </label>
                                  <Switch
                                    onChange={(event) => handleDataExportChange({nombre: 'horaFin'})}
                                    checked = {dataToExport['horaFin']}
                                    value={dataToExport['horaFin']}
                                    id = "horaFin"
                                    name = "horaFin"
                                    offColor = "#FF4961"
                                    onColor = "#28D094"
                                    disabled = {loading}
                                    className =  "col-md-6 align-middle"
                                  />
                                </div>
                               </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="modal-footer modal-grey">
                {loading ?
                  <button type="button" className="btn btn-default btn-fleet">
                    <i className={'la la-spinner spinner'}></i>
                    <FormattedMessage id="formularioGrid.render.export_modal.finish_button.exportar_a_excel_cargando" defaultMessage=" Preparando" />
                  </button>
                  :
                  <button type="button" className="btn btn-default btn-fleet" onClick={handleExport} disabled={!tipoFormulario}>
                    <i className={loading ? 'la la-spinner spinner' : 'fa fa-download'}></i>
                    <FormattedMessage id="formularioGrid.render.export_modal.finish_button.exportar_a_excel" defaultMessage=" Exportar a Excel" />
                  </button>
                }
                <button
                  type="button" className="btn btn-danger" disabled={loading} onClick={() => props.setModalExport(false)}>
                  <i className="fa fa-times-circle"></i>
                  <FormattedMessage id="formularioGrid.render.export_modal.finish_button.cancelar" defaultMessage=" Cancelar" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </Grow>
    </Modal>
  )
}

export default FormulariosGridExport
